import { render } from "./FormDefaultNewStepTwo.vue?vue&type=template&id=8c0bf224&scoped=true"
import script from "./FormDefaultNewStepTwo.vue?vue&type=script&lang=js"
export * from "./FormDefaultNewStepTwo.vue?vue&type=script&lang=js"

import "./FormDefaultNewStepTwo.vue?vue&type=style&index=0&id=8c0bf224&scoped=true&lang=css"
import "./FormDefaultNewStepTwo.vue?vue&type=style&index=1&id=8c0bf224&lang=scss"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c0bf224"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSelect,QInput,QItem,QItemSection});
